import React from 'react';
import i18n from 'i18next';
import { connect } from 'react-redux';
import ButtonUser from './button-user';
import ButtonMinihub from './button-minihub';
import { Link } from 'react-router-dom';
import { Popover, PopoverBody } from 'reactstrap';

import {
  setMessageFilterKey,
  setMessageFilterKeyword,
  setEventFilterKeyword,
  setShowFilterEventFields,
  setIsFilterDate,
  setIsSearchTopBar,
  setShowSettingsPopover,
  setShowFilterSearch,
  clearUserCredentials,
  setShowUserSignPopover,
  setShowDefaultCalendarPopover,
  setShowUserTemplatePopover
} from "../../actions/application";
import { lexonCredentialsClear } from '../../actions/lexon';
import HelpCenter from '../help-center/help-center';
import { removeState } from '../../services/state';
import { getCredentials } from '../../selectors/application';
import './top-bar-message-list.scss';
import AccountUser from '../menu-user/account-user/account-user';
import {
  getUser,
  resetDefaultAccount,
  getEncodeProducts
} from '../../services/accounts';
import { setCurrentUser, currentUserCredentialsClear } from '../../actions/user';
import { getFirstSyncCompleted } from '../../selectors/folders';
import ConfigIcon from '../../assets/icons/header/config.svg?react';
import FirmaIcon from '../../assets/icons/firma/firma.svg?react';
import CambiarCuentaIcon from '../../assets/icons/firma/cambiar-cuentra.svg?react';
import AñadirCuentaIcon from '../../assets/icons/firma/añadir-cuenta.svg?react';
import CalendarioIcon from '../../assets/icons/firma/calendario.svg?react';
import PlantillasIcon from '../../assets/icons/firma/plantillas.svg?react';
import SearchIcon from '../../assets/icons/search-grey.svg?react';
import SearchEmail from './SearchEmail';
import SearchEmailOld from './SearchEmailOld';
import FilterIcon from "../../assets/calendar/filter.svg?react";
import FilterCheckIcon from "../../assets/icons/top-bar-icons/filter-check.svg?react";

export class TopBarMessageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      searchEventsTerm: '',
      isSettingsPopoverId: false,
      isShowFilterSearch: false,
      showAccountChange: false,
      accounts: [],
      sign: '',
      defaultCalendar: null,
      loading: false,
      encodeUrl: ''
    };
  }

  componentDidMount() {
    const { currentUser, lexon } = this.props;

    if (currentUser.idClienteNavision) {
      getEncodeProducts(currentUser.idClienteNavision, lexon.lexonToken)
        .then(result => {
          if (result.errors.length === 0) {
            this.setState({ encodeUrl: result.data });
          } else {
            let errors;
            result.errors.forEach(error => {
              errors = `${error} `;
            });
            console.error('error ->', errors);
          }
        })
        .catch(error => {
          console.error('error ->', error);
        });
    }

    this.loadUser();
    this.props.setShowSettingsPopover(false);
    this.props.setShowFilterSearch(false);

    this.setState({ setTypeSearch: 'body' });

    const existSettingsPopoverId = document.querySelector('#settings-popover');
    if (existSettingsPopoverId) {
      this.setState({ isSettingsPopoverId: true });
    }

    const existShowFilterSearch = document.querySelector('#filter-search-bar');
    if (existShowFilterSearch) {
      this.setState({ isShowFilterSearch: true });
    }
    console.log("enter componentDidMount TopBarMessageList ");
  }

  loadUser() {
    const { lexon, currentUser } = this.props;
    if (lexon.userId) {
      this.setState({ loading: true }, () => {
        getUser(lexon.userId, lexon.lexonToken, false, currentUser.env)
          .then(result => {
            if (!result) {
              throw new Error('Error getting user');
            }

            window.currentUser = result.data?.tokenDecoded;
            this.props.setCurrentUser(result.data?.tokenDecoded);

            if (result.errors.length === 0) {
              this.setState({
                loading: false,
                sign: result.data.accounts[0].sign,
                accounts: result.data.accounts,
                defaultCalendar: lexon.configCalendar
                  ? lexon.configCalendar.account
                  : lexon.account
              });
            } else {
              let errors;
              this.setState({
                loading: false
              });
              result.errors.forEach(error => {
                errors = `${error} `;
              });
              console.log('error ->', errors);
            }
          })
          .catch(error => {
            this.setState({
              loading: false
            });
            console.log('error ->', error);
          });
      });
    }
  }

  routeLogout() {
    const { userId, token, lexonToken } = this.props.lexon;
    if (userId !== null) {
      resetDefaultAccount(userId, lexonToken)
        .then(() => {
          removeState();
        })
        .then(() => {
          //Call action to reset all redux info
          this.props.logout();
          const urlRedirect = token
            ? `${window.URL_SELECT_ACCOUNT}/access/${token}/`
            : `${window.URL_SELECT_ACCOUNT}/user/${userId}/encrypt/0`;
          window.location.replace(urlRedirect);
        });
    } else {
      removeState();
      window.location.reload();
    }
  }

  handleAddAccount() {
    this.routeLogout();
  }

  handleInputChange(evt) {
    this.props.setSearchQuery(evt.target.value);
    this.performSearch();
  }

  handleSearchClick() {
    if (this.props.searhQuery !== '') {
      this.performSearch();
    }
  }

  onEventSearch = () => {
    if (
      this.state.searchEventsTerm !== null &&
      this.state.searchEventsTerm !== undefined &&
      this.state.searchEventsTerm !== ''
    ) {
      this.props.setEventFilterKeyword(this.state.searchEventsTerm);
      this.props.setIsSearchTopBar(true);
    } else {
      this.props.setEventFilterKeyword('');
      this.props.setIsSearchTopBar(false);
    }
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.onEventSearch();
    }
  };

  handleSignChange = content => {
    this.setState({ sign: content });
  };

  handleCloseAccountModal = () => {
    this.setState({ showAccountChange: false });
  };

  handleDefaultCalendarChange = account => {
    this.setState({ defaultCalendar: account });
  };

  handleLogoClick = (event) => {
    event.preventDefault();
    window.location.reload();
  }

  render() {
    const {
      hiddeSearch,
      showSearchEvents,
      eventFilterKeyword,
      isFilterDate,
      isSearchTopBar,
      showSettingsPopover,
      showFilterSearch,
      isEmail,
      firstSyncCompleted,
      showFilterEventFields,
    } = this.props;

    const {
      isSettingsPopoverId,
      isShowFilterSearch,
      showAccountChange,
      setTypeSearch,
      accounts,
      sign,
      defaultCalendar,
      encodeUrl
    } = this.state;
    const accSelectorList = accounts.filter(acc => acc.defaultAccount !== true);
    return (
      <div
        className={` 
          d-flex p-3 align-content-center align-items-center 
          ${showSearchEvents ? 'calendar-header' : 'header'}`}
      >
        <div className={`justify-content-left ${'logo-space-img'}`}>
          <Link onClick={this.handleLogoClick}>
            <img
              className={`${'main-header-img'}`}
              border="0"
              alt="Lefebvre"
              src="assets/images/logo-lefebvre.svg"
            ></img>
          </Link>
        </div>
        <div className="header-logo justify-content-center"></div>
        <div className={` ${'header-search'}`}>
          {!hiddeSearch && firstSyncCompleted &&
            <SearchEmail />
          }
          { !hiddeSearch && !firstSyncCompleted &&
            <SearchEmailOld />
          }
          {isShowFilterSearch &&
            <Popover
              trigger="legacy"
              isOpen={showFilterSearch}
              target="filter-search-bar"
              toggle={() => {
                this.props.setShowFilterSearch(false);
              }}
              placement="bottom"
              className="popover-filter-date-events"
            >
              <PopoverBody>
                <div className="menu-option-container">
                  <div
                    className={`
                      d-flex 
                      align-items-center 
                      change-account-container 
                      ${setTypeSearch === 'body' ? 'active-option' : ''}`}
                    onClick={() => {
                      this.props.setShowFilterSearch(false);
                      this.setState({
                        setTypeSearch: 'body'
                      });
                    }}
                  >
                    <span className="change-account-text">
                      {i18n.t('topBar.filter.body')}
                    </span>
                  </div>
                  <div
                    className={`
                      d-flex 
                      align-items-center 
                      add-account-container 
                      ${setTypeSearch === 'subject' ? 'active-option' : ''}`}
                    onClick={() => {
                      this.props.setShowFilterSearch(false);
                      this.setState({
                        setTypeSearch: 'subject'
                      });
                    }}
                  >
                    <span className="change-account-text">
                      {i18n.t('topBar.filter.subject')}
                    </span>
                  </div>
                </div>
              </PopoverBody>
            </Popover>
          }

          {hiddeSearch &&
            showSearchEvents && ( //Calendar
            <div className="d-flex w-100 justify-content-end align-items-center">
              <div className="top-search-bar-container">
                <input
                  type="search"
                  placeholder={i18n.t('topBar.search-event')}
                  value={this.state.searchEventsTerm}
                  onChange={event => {
                    this.setState({ searchEventsTerm: event.target.value });
                    this.props.setEventFilterKeyword(event.target.value);
                  }}
                  onKeyDown={this.handleKeyDown}
                  className="top-search-bar-input"
                />
                <div className="top-divider-icon-container">
                  <div className="top-search-bar-divider" />
                  {(this.state.searchEventsTerm === '' ||
                      eventFilterKeyword === '' ||
                      isFilterDate ||
                      !isSearchTopBar) && (
                    <SearchIcon
                      className="top-search-icon"
                      onClick={() => {
                        this.onEventSearch();
                      }}
                    />
                  )}
                  {((eventFilterKeyword !== '' &&
                      this.state.searchEventsTerm !== '') ||
                      isFilterDate) && (
                    <span
                      className="lf-icon lf-icon-close top-close-icon"
                      onClick={() => {
                        this.props.setEventFilterKeyword('');
                        this.props.setIsSearchTopBar(false);
                        this.setState({ searchEventsTerm: '' });
                        this.props.setIsFilterDate(false);
                      }}
                    ></span>
                  )}
                </div>
              </div>
              <span
                id="filter-date-popover"
                onClick={() => {
                  this.props.setShowFilterEventFields(true);
                }}
                style={{ marginLeft: '15px', cursor: 'pointer', display: 'inline-flex', marginRight: '-13px' }}
              >
                <div
                  style={{ backgroundColor: showFilterEventFields  ? 'var(--chill-air)' : 'transparent' }} 
                  className="filter-date-popover-icon-container">{isFilterDate ? (
                    <FilterCheckIcon fill="var(--gray-800)" width="29" height="29" />
                    ) : (
                    <FilterIcon width="25" height="25" />
                    )}
                </div>
              </span>
            </div>
          )}

          <ConfigIcon
            className={`lf-icon lf-icon-configuration ${
              'lf-icon-configuration'
            } ${isEmail ? 'lf-icon-configuration-email' : ''}`}
            onClick={() => {
              this.props.setShowSettingsPopover(!showSettingsPopover);
            }}
            id="settings-popover"
            fill="rgba(70, 70, 70, 1)"
          />
          {isSettingsPopoverId && (
            <Popover
              trigger="legacy"
              isOpen={showSettingsPopover}
              target="settings-popover"
              toggle={() => {
                this.props.setShowSettingsPopover(false);
              }}
              placement="bottom"
              className="popover-filter-date-events"
            >
              <PopoverBody>
                <div className="pt-2 menu-option-container">
                  {!showSearchEvents && (
                    <div
                      className="d-flex align-items-center change-account-container"
                      onClick={() => {
                        this.props.setShowSettingsPopover(false);
                        this.props.setShowUserSignPopover(true);
                      }}
                      id="user-sign-popover"
                    >
                      <FirmaIcon assName="lf-icon lf-icon-feather mr-2" />
                      <span className="change-account-text ml-2">
                        {i18n.t('menu-user.email-signature')}
                      </span>
                    </div>
                  )}
                  <div
                    className="d-flex align-items-center change-account-container"
                    onClick={() => {
                      this.props.setShowSettingsPopover(false);
                      this.loadUser();
                      this.setState({
                        showAccountChange: true
                      });
                    }}
                  >
                    <CambiarCuentaIcon className="lf-icon lf-icon-change mr-2" />
                    <span className="change-account-text">
                      {i18n.t('menu-user.change-account')}
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center add-account-container"
                    onClick={() => {
                      this.handleAddAccount();
                      this.props.setShowSettingsPopover(false);
                    }}
                  >
                    <AñadirCuentaIcon className="lf-icon lf-icon-add-round mr-2" />
                    <span className="add-account-text">
                      {i18n.t('menu-user.add-account')}
                    </span>
                  </div>
                  {!showSearchEvents && (
                    <div
                      className="d-flex align-items-center change-account-container"
                      onClick={() => {
                        this.props.setShowSettingsPopover(false);
                        this.props.setShowDefaultCalendarPopover(true);
                      }}
                    >
                      <CalendarioIcon className="lf-icon lf-icon-calendar-check mr-2" />
                      <span className="change-account-text">
                        {i18n.t('menu-user.default-calendar')}
                      </span>
                    </div>
                  )}
                  {!showSearchEvents && (
                    <div
                      className="d-flex align-items-center change-account-container"
                      onClick={() => {
                        this.props.setShowSettingsPopover(false);
                        this.props.setShowUserTemplatePopover(true);
                      }}
                    >
                      <PlantillasIcon className="lf-icon lf-icon-newsletter mr-2" />
                      <span className="change-account-text">
                        {i18n.t('menu-user.email-template')}
                      </span>
                    </div>
                  )}
                </div>
              </PopoverBody>
            </Popover>
          )}
          <AccountUser
            accSelectorList={accSelectorList}
            showAccountChange={showAccountChange}
            handleCloseAccountModal={this.handleCloseAccountModal}
          />

          <div className={` ${'divider-search-user'}`} />

          <ButtonUser
            className={`${'modules-item-custom'}`}
            hiddeSign={this.props.hiddeSearch}
            showSearchEvents={showSearchEvents}
            handleSignChange={this.handleSignChange}
            sign={sign}
            accounts={accounts}
            defaultCalendar={defaultCalendar}
            handleDefaultCalendarChange={this.handleDefaultCalendarChange}
            encodeUrl={encodeUrl}
          />
          <HelpCenter encodeUrl={encodeUrl} />
          {window.location === window.parent.location ? (
            <ButtonMinihub className={`${'modules-item-custom'}`} />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventFilterKeyword: state.application.eventFilterKeyword,
  isFilterDate: state.application.isFilterDate,
  isSearchTopBar: state.application.isSearchTopBar,
  showSettingsPopover: state.application.showSettingsPopover,
  showFilterSearch: state.application.showFilterSearch,
  showFilterEventFields: state.application.showFilterEventFields,
  application: state.application,
  credentials: getCredentials(state),
  login: state.login,
  lexon: state.lexon,
  currentUser: state.currentUser,
  firstSyncCompleted: getFirstSyncCompleted(state)
});

const mapDispatchToProps = dispatch => ({
  setMessageFilter: messageFilter =>
    dispatch(setMessageFilterKey(messageFilter)),
  setMessageFilterKeyword: keyword =>
    dispatch(setMessageFilterKeyword(keyword)),
  setEventFilterKeyword: eventFilterKeyword =>
    dispatch(setEventFilterKeyword(eventFilterKeyword)),
  setIsSearchTopBar: isSearchTopBar =>
    dispatch(setIsSearchTopBar(isSearchTopBar)),
  setShowFilterEventFields: showFilterEventFields =>
    dispatch(setShowFilterEventFields(showFilterEventFields)),
  setShowSettingsPopover: showSettingsPopover =>
    dispatch(setShowSettingsPopover(showSettingsPopover)),
  setShowFilterSearch: showFilterSearch =>
    dispatch(setShowFilterSearch(showFilterSearch)),
  setShowUserSignPopover: showUserSignPopover =>
    dispatch(setShowUserSignPopover(showUserSignPopover)),
  setShowUserTemplatePopover: showUserTemplatePopover =>
    dispatch(setShowUserTemplatePopover(showUserTemplatePopover)),
  setShowDefaultCalendarPopover: showDefaultCalendarPopover =>
    dispatch(setShowDefaultCalendarPopover(showDefaultCalendarPopover)),
  setIsFilterDate: isFilterDate => dispatch(setIsFilterDate(isFilterDate)),
  setCurrentUser: user => dispatch(setCurrentUser(user)),
  logout: () => {
    dispatch(clearUserCredentials());
    dispatch(lexonCredentialsClear());
    dispatch(currentUserCredentialsClear());
  }
});

const ConnectedTopBarMessageList = connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBarMessageList);

export default ConnectedTopBarMessageList;
